import React from 'react';
import type {ItemFormErrors, ItemFormValues, UseItemForm} from '../../hooks/useItemForm';
import type {ItemFormRefs} from './types';
import {SelectField, TextField} from './ItemFormControls';

export interface ItemFormBasicsProps {
    values: ItemFormValues;
    errors: ItemFormErrors;
    refs: ItemFormRefs;
    setField: UseItemForm['setField'];
}

/**
 * Главное о вещи: название, категория, описание. Секция открыта во всех
 * режимах — «фото → название → категория → Добавить» должно умещаться на первом
 * экране без скролла (QA-13).
 */
const ItemFormBasics: React.FC<ItemFormBasicsProps> = ({values, errors, refs, setField}) => (
    <>
        <TextField
            id="item-name"
            label="Название"
            required
            value={values.name}
            error={errors.name}
            placeholder="Например: Синяя рубашка"
            onChange={v => setField('name', v)}
        />
        <SelectField
            id="item-category"
            label="Категория"
            value={values.categoryId}
            options={refs.categories}
            onChange={v => setField('categoryId', v)}
        />
        <div>
            <label htmlFor="item-description" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Описание
            </label>
            <textarea
                id="item-description"
                data-testid="item-description"
                value={values.description}
                onChange={e => setField('description', e.target.value)}
                className="input-field min-h-[112px] resize-y"
                rows={4}
            />
        </div>
    </>
);

export default ItemFormBasics;
